import { VelavuStreamUpdateOperation, VelavuStreamUpdateTarget } from "velavu-js-api";
import { useVelavuStream } from "../stream/StreamContext";
import { useCallback } from "react";
/**
 * A hook that listens to device movement updates and calls the callback with the update.
 * NOTE: When using this function, always check if the date associated with the location
 * is newer than the last update.
 * @param callback The callback to call with each device movement update
 */
export function useDeviceMovementListener(callback) {
    useVelavuStream(VelavuStreamUpdateTarget.Event, useCallback((event) => {
        if (event.operation === VelavuStreamUpdateOperation.Created
            && event.body.category === "LOCATION") {
            callback({
                deviceID: event.body.device_id,
                location: event.body.data,
            });
        }
    }, [callback]));
}
//# sourceMappingURL=deviceMoveHook.js.map